<script>
export default {
  props: {
    value: [String, Array],
    multiple: Boolean,
  },

  data: () => ({
    availableEggMobiles: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', 'Ekhaya', 'Old'],
  }),

  computed: {
    selectOptions() {
      return (this.multiple ? [] : [{ value: '', text: 'Select egg mobiles...' }])
        .concat(this.availableEggMobiles.map(x => ({ value: x, text: x })));
    },
  },
}
</script>

<template>
  <div class="position-relative">
    <b-form-group label="Egg mobiles" :label-for="`select-${_uid}`">
      <b-form-select
        :value="value"
        @input="$emit('input', $event)"
        @change="$emit('change', $event)"
        :id="`select-${_uid}`"
        :options="selectOptions"
        v-bind="$attrs"
        :multiple="multiple"
        plain>
      </b-form-select>
    </b-form-group>
  </div>
</template>



// WEBPACK FOOTER //
// src/layerAdmin/components/EggMobileChooser.vue